import OfferDolly from './OfferDolly';

export default OfferDolly;
